import React from 'react';
import PropTypes from 'prop-types';
import ThrowInDev from 'Helpers/ThrowInDev';
import { Summary } from './summary';
import { NormalStep } from './normalStep';

// Similar concept to webapp/src/Views/Page/Content/Templates/index.js
// You map resource types to components that get rendered
const templates = {
  PlanSummaryPhaseSummary: Summary,
  PlanSummaryPhaseStep: NormalStep,
};

export function StepPicker({
  resource, expanded, onExpandedChange,
}) {
  const Component = templates[resource.type()];
  if (!Component) {
    return <ThrowInDev err={`StepPicker received ${resource.type()} but there is no component for that`} />;
  }
  return (
    <Component resource={resource} expanded={expanded} onExpandedChange={onExpandedChange} />
  );
}
StepPicker.defaultProps = {
};

StepPicker.propTypes = {
  resource: PropTypes.object.isRequired,
  expanded: PropTypes.bool.isRequired,
  onExpandedChange: PropTypes.func.isRequired,
};
